/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import { Typography } from "@material-ui/core";

/* Data Imports */

import AppConfig from "../../../../AppConfig";

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "center",
    },
    justifyContent: "space-between",
    alignItems: "center",
    height: "calc(100vh - 4rem)",
    width: "100%",
    margin: "0rem 0rem 1rem 0rem",
  },
  text: {
    [theme.breakpoints.between("sm", "md")]: {
      marginRight: "2rem",
    },
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  heading: {
    width: "100%",
    color: "#000000",
    fontWeight: "400",
    fontSize: "3rem",
    lineHeight: "4.5rem",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
      lineHeight: "2.25rem",
    },
  },
  boldRed: {
    color: "#CC0000",
    fontWeight: "bold",
    background: "-webkit-linear-gradient(#F74134, #EB1C61)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
  },
  subHeading: {
    margin: "0.5rem 0rem 0.5rem 0rem",
    width: "100%",
    color: "#666666",
    fontWeight: "400",
    fontSize: "1.125rem",
    lineHeight: "1.75rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.125rem",
      lineHeight: "1.6875rem",
    },
  },
  illustrationSizer: {
    marginTop: "1rem",
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      height: "280px",
      width: "280px",
    },
    [theme.breakpoints.only("xs")]: {
      height: "310px",
      width: "310px",
    },
    [theme.breakpoints.only("sm")]: {
      height: "352px",
      width: "352px",
    },
    [theme.breakpoints.only("md")]: {
      height: "384px",
      width: "384px",
    },
    [theme.breakpoints.only("lg")]: {
      height: "512px",
      width: "512px",
    },
    [theme.breakpoints.only("xl")]: {
      height: "512px",
      width: "512px",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      height: "768px",
      width: "768px",
    },
  },
}));

const SectionOne = () => {
  const classes = useStyles();

  // Replace LQIP images with animated svgs

  const [lqipIllustrationSrc, setLqipIllustrationSrc] = React.useState(
    "/images/illustrations/reward/rewards.webp",
  );

  React.useEffect(() => {
    setLqipIllustrationSrc("/images/illustrations/reward/rewards.svg");
  }, []);

  return (
    <React.Fragment>
      <div className={classes.sectionContainer}>
        <div className={classes.text}>
          <Typography variant="h1" component="h1" className={classes.heading}>
            <span className={classes.boldRed}>Lighter Advisory</span> Reward Program
          </Typography>
          <Typography
            variant="body2"
            component="span"
            className={classes.subHeading}
          >
            A one of its kind program which enables you to make a fortune with a
            single phone call
          </Typography>
        </div>
        <div>
          <img
            src={lqipIllustrationSrc}
            alt={AppConfig.imageAltText}
            width={512}
            height={512}
            loading="eager"
            referrerPolicy="no-referrer"
            className={classes.illustrationSizer}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default SectionOne;
